import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Divider, Box, Typography } from '@mui/material';
import SuiButton from "../../components/SoftButton";
import { IoClose } from "react-icons/io5";
import {runSelectedServices, getNonExecutedServices} from "../../axios-client";
import PropTypes from "prop-types";
import Services from "./components/Services";
import { useTranslation } from "react-i18next";
const RunNonExecutedServices = ({open, onClose, id, sourceLanguage, targetLanguage, refreshList, setNotification}) => {
    const [formData, setFormData] = useState({
        services: [],
        audioFormat: '',
        voiceName: ''
    });
    const [errors, setErrors] = useState({});
    const [services, setServices] = useState([]);
    const [totalCost, setTotalCost] = useState(0);
    const { i18n, t } = useTranslation("publicationsTranslation");
    const currentLanguage = i18n.language;
    const dir = i18n.dir();

    const validateForm = () => {
        let newErrors = {};
        const audioBookService = services.find(service => service.name === 'Text to Speech');
        if(formData.services?.includes(audioBookService?.id)){
            if (!formData.audioFormat) newErrors.audioFormat = 'Audio format is required';
            if (!formData.voiceName) newErrors.voiceName = 'Voice Name is required';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    useEffect(() => {
        const selectedServiceCosts = services
            .filter(service => formData.services.includes(service.id))
            .reduce((acc, service) => acc + (service.price || 0), 0);

        setTotalCost(selectedServiceCosts.toFixed(2));
    }, [formData.services, services]);

    useEffect(() => {
        if(open){
            getNonExecutedServices(id)
                .then(res => {
                    setServices(res.data);

                    const defaultSelectedServices = res.data.filter(service => (service.pre_selected == true)).map(key => key.id);

                    setFormData(prevState => ({
                        ...prevState,
                        services: defaultSelectedServices
                    }));
                })
                .catch(error => {
                    console.error('Error fetching services:');
                });
        }
    }, [open]);

    const handleService = (e, serviceId) => {

        if (formData.services.includes(serviceId)) {
            setFormData(prevState => ({
                ...prevState,
                services: formData.services.filter(key => key != serviceId)
            }));
        } else {
            setFormData(prevState => ({
                ...prevState,
                services: [...prevState.services, serviceId]
            }));
        }
    }

    const handleRun =  () => {
        if (validateForm()){
            runSelectedServices(id, {services:formData.services, total_cost: totalCost,
                voiceName:formData.voiceName, audioFormat:formData.audioFormat}).then(()=>{
                onClose()
                refreshList()
            }).catch((e)=>{
                onClose()
                setNotification({
                    show: true,
                    snackbarMessage: 'An error occurred. Please try again later.',
                    severity: 'error'
                });
            })
        }
    };

    return (
        <Dialog open={open} aria-labelledby="form-dialog-title" maxWidth="sm" fullWidth PaperProps={{ style: { borderRadius: 15 } }}>
            <DialogTitle
                id="form-dialog-title"
                sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
            >
                {t("RunNon-ExecutedServices")}
                <IoClose
                    aria-label="close"
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        ...(dir === 'rtl' ? { left: '0.875rem' } : { right: '0.875rem' }),
                        top: 8,
                        cursor: 'pointer'
                    }}
                />
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ padding: "0px 24px" }}>

                <Services label={t("services")}
                          formData={formData}
                          setFormData={setFormData}
                          selectedLanguage={sourceLanguage.toLowerCase()}
                          selectedTargetLanguage={targetLanguage.toLowerCase()}
                          services={services} selectedServices={formData.services}
                          handleCheckboxServiceChange={handleService}
                          errors={errors}
                          setErrors={setErrors}
                />

                <Box
                    sx={{
                        textAlign: 'center',
                        p: 2,
                        backgroundColor: '#fffff',
                        borderRadius: 2,
                        border: '1px solid #cce4f7',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                        mt: 2,
                    }}
                >
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#0066cc' }}>
                        {t("totalCost")}: ${totalCost}
                    </Typography>
                </Box>

            </DialogContent>
            <Divider />
            <DialogActions>
                <SuiButton variant="gradient" color="secondary" size="medium" onClick={onClose}  sx={{ml: 1, mr:  (dir === 'rtl' ? 1 : 0)}}>{t("close")}</SuiButton>
                <SuiButton variant="gradient" color="primary" size="medium" onClick={handleRun}>
                    {t("add")}
                </SuiButton>
            </DialogActions>
        </Dialog>
    );
};

RunNonExecutedServices.propTypes = {
    id: PropTypes.number,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    refreshList: PropTypes.func,
    setNotification: PropTypes.func,
    sourceLanguage: PropTypes.string,
    targetLanguage: PropTypes.string,
}
export default RunNonExecutedServices;